import * as BABYLON from '@babylonjs/core'

function dataUrlToFile(dataUrl: string, filename: string): File {
  const [header, data] = dataUrl.split(',')
  const mime = /data:([^;]+)/.exec(header)?.[1] || 'image/png'
  const binary = atob(data)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
  return new File([bytes], filename, { type: mime })
}

/**
 * Capture the live Studio view from the active camera (orbit / walk / plan).
 * Uses a render-target screenshot so UI chrome overlays are not burned in.
 */
export function captureStudioScreenshot(
  scene: BABYLON.Scene,
  opts?: { width?: number; height?: number },
): Promise<File> {
  const engine = scene.getEngine()
  const camera = scene.activeCamera
  if (!engine || !camera) {
    return Promise.reject(new Error('Studio scene is not ready'))
  }

  const width = opts?.width ?? Math.min(1920, engine.getRenderWidth() || 1280)
  const height = opts?.height ?? Math.round(width * ((engine.getRenderHeight() || 720) / (engine.getRenderWidth() || 1280)))

  return new Promise((resolve, reject) => {
    try {
      BABYLON.Tools.CreateScreenshotUsingRenderTarget(
        engine,
        camera,
        { width, height },
        (data) => {
          if (!data || typeof data !== 'string') {
            reject(new Error('Screenshot failed'))
            return
          }
          resolve(dataUrlToFile(data, `egowall-studio-${Date.now()}.png`))
        },
      )
    } catch (err) {
      reject(err instanceof Error ? err : new Error('Screenshot failed'))
    }
  })
}
